import React from 'react';
import { Section } from './Section';
import { Feather, Eye, Maximize, Clock, ShieldCheck } from 'lucide-react';
const features = [{
  icon: Feather,
  title: 'Diseño ultra liviano',
  description: 'Solo 165 gramos. Apenas notarás que la llevas puesta.'
}, {
  icon: Eye,
  title: 'Luz suave que no cansa la vista',
  description: '3 tonos: cálida, neutra y blanca, con tecnología anti-parpadeo.'
}, {
  icon: Maximize,
  title: 'Flexible y portátil',
  description: 'Brazo manguera adaptable. Se pliega para llevar a cualquier lado.'
}, {
  icon: Clock,
  title: 'Hasta 20 horas de batería',
  description: 'Autonomía prolongada con indicador digital en pantalla.'
}, {
  icon: ShieldCheck,
  title: 'Materiales resistentes',
  description: 'Silicona premium suave al tacto, terminación negro mate.'
}];
export function WhyDifferent() {
  return <Section className="bg-[#0A0A0A] text-white rounded-[2rem] md:rounded-[3rem] my-8 md:my-12" data-id="element-192">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-start py-4" data-id="element-193">
        <div className="lg:col-span-5 lg:sticky lg:top-32" data-id="element-194">
          <p className="text-sm font-medium text-[#FF6B1A] tracking-widest uppercase mb-4" data-id="element-195">
            Características
          </p>
          <h2 className="text-4xl md:text-5xl font-light tracking-tight leading-tight text-balance mb-8" data-id="element-196">
            ¿Por qué esta luz es{' '}
            <span className="text-[#FF6B1A] font-semibold" data-id="element-197">diferente</span>?
          </h2>
          <p className="text-white/60 font-light text-lg max-w-md" data-id="element-198">
            Pensada en cada detalle para acompañarte donde sea que vayas.
          </p>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 flex flex-col" data-id="element-199">
          {features.map((feature, index) => <div key={index} className="flex gap-6 items-start py-8 border-b border-white/10 last:border-b-0 group" data-id="element-200">
              <div className="mt-1 w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center text-[#FF6B1A] group-hover:bg-[#FF6B1A] group-hover:text-white transition-all duration-300 flex-shrink-0" data-id="element-201">
                <feature.icon strokeWidth={1.5} size={22} data-id="element-202" />
              </div>
              <div data-id="element-203">
                <h3 className="text-xl font-semibold mb-2" data-id="element-204">{feature.title}</h3>
                <p className="text-white/60 font-light text-base" data-id="element-205">
                  {feature.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}